module.exports = function() {
  return new Worker(__webpack_public_path__ + "e0e279f6a3829b2f4d23.worker.js");
};